import type { IResponse } from '@/features/api/extranet'
import { type IContextsAppProvider } from '@/features/auth'
import { useFetch, ensureSuccessStatusCode } from '@/features/fetch'
import type { ContextsApp, PermissionsApp } from './types'

type ContextsAppDTO = {
  [p in Capitalize<keyof ContextsApp>]: PermissionsApp
}

export function useContextsAppProvider(): IContextsAppProvider {
  const fetch = useFetch('extranet')

  async function getContextsAppAsync(): Promise<ContextsApp> {
    const response = await fetch('/user/permissions', {
      dialogMode: 'retry',
      sablier: true,
    })
    ensureSuccessStatusCode(response)
    const result = (await response.json()) as IResponse<ContextsAppDTO>

    return {
      adherent: result.data.Adherent,
      prestataire: result.data.Prestataire,
    }
  }

  return { getContextsAppAsync }
}
